import { initApp } from './App';

document.addEventListener('DOMContentLoaded', () => {
	initApp();
});
